export default {"src":"/_next/static/media/client-2-3.2cbd5eff.svg","height":42,"width":160,"blurWidth":0,"blurHeight":0};